const MyWeight = () => {
	return (
		<div className='myWeight' >
			<img src='/images/mybody/myweightheb.jpg' />
		</div>
	)
}

export default MyWeight